import styled from 'styled-components';
import { colors } from '../../utils';

export const PageContainer = styled.div`
  background-color: ${colors.blackRock};
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;


// WEBPACK FOOTER //
// ./src/pages/Dashboard/styled.js